import { render, staticRenderFns } from "./OnGoingSchemeDetails.vue?vue&type=template&id=15507144"
import script from "./OnGoingSchemeDetails.vue?vue&type=script&lang=js"
export * from "./OnGoingSchemeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports